/* eslint 'jsx-a11y/anchor-is-valid': 'off', 'no-useless-concat': 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import "Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css";
import "Assets/Reports/reportsDefinitions.css";
import "Assets/Reports/greenTable.css";
import classnames from "classnames";
import {
  Table,
  UncontrolledButtonDropdown,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Modal,
  ModalFooter,
  Button,
  ModalBody,
  ModalHeader,
  Input,
} from "reactstrap";
import SearchInput, { createFilter } from "react-search-input";
import {
  getReportsList,
  getReportsSubList,
  runReports,
  DeleteReports,
  UpdateReportDefinition,
  getArtifactFilename,
  DownloadSelectedReport,
  getArtifactTemplate
} from "action/ReportManagement/ManageReports";
import Pagination from "rc-pagination";
import Select from "rc-select";
import SelectAllCheckboxes from "Resources/SelectAllCheckboxes";
import localeInfo from "rc-pagination/lib/locale/en_US";
import "rc-pagination/assets/index.css";
import "rc-select/assets/index.css";
import { FaSort } from "react-icons/fa";
import ViewRunHistory from "components/EnsembleComponents/ReportsManagement/_ViewRunHistory";
import EditName from "components/EnsembleComponents/ReportsManagement/_EditName";
import progressindicator from "Assets/images/ProgressIndicator.gif";
import errorImage from "Assets/images/Error.gif";
import DeleteConfirmation from "components/EnsembleComponents/TenantComponents/ManageTenants/_ModalsForms/DeleteConfirmation";
import { Redirect } from "react-router-dom";
import { setSelectedReportID } from "action/ReportManagement/ScheduleReport";
import { IconButton, createSvgIcon, Tooltip } from "@mui/material";
import { setAmplitudeEvent } from "amplitude/amplitude";
import TraneDragAndDrop from "./TraneDragandDrop";
import 'Assets/Reports/reportsDefinitions.css';
import ErrorGif from 'Assets/images/Error.gif';
import APIutil from "../../../api/APIutils";
import * as url from "../../../api/url";


const KEYS_TO_FILTERS = ["name", "typeName", "desc", "isScheduled"];
const MAX_GENERATE_ATTEMPTS = 30;

export const PlayIcon = createSvgIcon(
  <svg
    width="25"
    height="25"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_472_4801"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="25"
      height="25"
    >
      <rect width="25" height="25" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_472_4801)">
      <path
        d="M9.5 16.5L16.5 12L9.5 7.5V16.5ZM5 21C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>,
  "Play"
);
const windowFeatures =
  "resizable=1,status=yes,scrollbars=0,toolbar=0,titlebar=0,location=no,width=800,height=650,dialog=1,minimizable=1";
const windowName = "EnsembleVideoWindow";
const videoUrl =
  "https://vimeo.com/718039729/8d44f70ab6?share=copy&childpage=true";

class ManageReportsTabSystem extends Component {
  componentWillMount() {
    this.clearSelectedReportState();
    this.props.getReportsList();
    
  }

  componentDidUpdate(prevProps) {
    // Check if the ReportsList prop has changed from the previous props
    // and ensure it's an array before trying to access its length.
    if (
      prevProps.ReportsList !== this.props.ReportsList && prevProps.ReportsList.length !== this.props.ReportsList.length &&
      Array.isArray(this.props.ReportsList)
    ) {
      const reportsList = this.props.ReportsList;
      const totalReportCount = reportsList.length;

      // Count reports where isScheduled is true (assuming isScheduled is a boolean property)
      const scheduledReportsCount = reportsList.filter(report => report.isScheduled === true).length;
      // Log the count of the new ReportsList
      setAmplitudeEvent("View Report List Page", {
        'Number of Reports': totalReportCount,
        'Number of Scheduled Reports': scheduledReportsCount
      });
    }
  }

  constructor(props) {
    super(props);
    this.state = {
      closeCreate: false,
      closeActions: false,
      deleteModal: false,
      editNameModal: false,
      searchTerm: "",
      selectedReportId: 0,
      selectedReportType: 0,
      selectedNumArtifacts: 0,
      selectedReportName: "",
      selectedExtension: "",
      hasMultipleSelected: false,
      currentPagination: 1,
      pagination_records_PerPage: 50,
      viewrunhistory_Modal: false,
      customReportLink: this.constructBaseUrl("custom"),
      standardReportLink: this.constructBaseUrl("standard"),
      //dataExportLink: this.constructBaseUrl('export'),
      scheduleLink: this.constructBaseUrl("schedule"),
      IsRedirecttoDataExport: false,
      timerSpan: 0,
      shortReportList: [],
      sort: {
        column: "name",
        direction: "asc",
        icon: <FaSort />,
      },
      FileReportName: null,
      importFileModal: false,
      importFile: null,
      importFileNameError: false,
      importFileUploadError: false,
      importFileUploadErrorCode: "",
      openInEditor: false,
    };
    this.toggleCreate = this.toggleCreate.bind(this);
    this.toggleActions = this.toggleActions.bind(this);
    this.searchUpdated = this.searchUpdated.bind(this);
    this.viewrunhistory_toggle = this.viewrunhistory_toggle.bind(this);
    this.run_report_success = this.run_report_success.bind(this);
    this.setSelectedReports = this.setSelectedReports.bind(this);
    this.toggleDelete = this.toggleDelete.bind(this);
    this.toggleEditName = this.toggleEditName.bind(this);
    this.redirecttoDataExport = this.redirecttoDataExport.bind(this);
    this.redirecttoDataExportSchedules =
      this.redirecttoDataExportSchedules.bind(this);
    this.saveReportTemplate = this.saveReportTemplate.bind(this);
    this.checkReportTemplateName = this.checkReportTemplateName.bind(this);
  }

  viewDataExport(id, data) {
    sessionStorage.setItem("SelectedReportDetails", JSON.stringify(data));
    this.setState({ IsRedirecttoDataExport: true });
  }

  redirecttoDataExport() {
    this.setState({ IsRedirecttoDataExport: true });
  }

  redirecttoDataExportSchedules() {
    this.setState({ IsRedirecttoDataExport: true });
    sessionStorage.setItem("IsFromReportSchedules", true);
  }

  saveReportTemplate() {
    const data = {
      name: this.state.FileReportName,
      description: this.state.fileDescription,
      data: this.state.importFile,
    }


    APIutil.postData(url.post_reportManagement_template, data)
      .then((res) => {
        setAmplitudeEvent("Custom Report Import Template", {
          'Open In Editor': this.state.openInEditor? "True" : "False" 
      });
        // redirect user to report page if open editor is checked
        if (res.status === 200) {

          if (this.state.openInEditor === true) {
            let rptLinkForReport = this.state.customReportLink + "?ReportId=";
            // redirect user to rptLinkForReport
            window.location.href = rptLinkForReport + res.data;          
            this.clearStateValues();

          }else{
            this.props.getReportsList();
            this.clearStateValues();

          }
        } else if (res.status === 400) {

          this.setState({
            importFileUploadError: true,
            importFileUploadErrorCode: res.status,
          });
        } else if (res.status === 500) {
          this.setState({
            importFileUploadError: true,
            importFileUploadErrorCode: res.status,
          });
        } else if (res.status === 401) {
          this.setState({
            importFileUploadError: true,
            importFileUploadErrorCode: res.status,
          });
        }
      })
      .catch((error) => {
        throw error;
      });
  }

  clearStateValues() {
    this.setState({
      importFileModal: false,
      importFile: null,
      FileReportName: null,
      importFileNameError: false,
      importFileUploadError: false,
      importFileUploadErrorCode: "",
      openInEditor: false,
    });
  }

  hideErrorMessages() {
    document.getElementById('dupError').style.display = 'none';
    document.getElementById('illegalCharError').style.display = 'none';
    document.getElementById('tooManyCharacters').style.display = 'none';
    document.getElementById('reportName').style.border = '1px solid black';
  }

  checkReportTemplateName() {
    this.hideErrorMessages();

    var revisedName = this.state.FileReportName.trim().toLowerCase();
    var rEx = '^[a-zA-Z0-9_.,() $:!&-]*$';

    if (revisedName.length > 50) {
      document.getElementById('tooManyCharacters').style.display = 'block';
      document.getElementById('reportName').style.border = '1px solid red';

      this.setState({
        importFileNameError: true,
      })
    } else if (revisedName.match(rEx) !== null) {

      const found = this.props.ReportsList.find(element => element.name.toLowerCase() === revisedName);

      if (!found) {
        this.setState({
          importFileNameError: false,
        })

        this.saveReportTemplate();
      }
      else {
        document.getElementById('dupError').style.display = 'block';
        document.getElementById('reportName').style.border = '1px solid red';

        this.setState({
          importFileNameError: true,
        })
      }

    } else {
      document.getElementById('illegalCharError').style.display = 'block';
      document.getElementById('reportName').style.border = '1px solid red';

      this.setState({
        importFileNameError: true,
      })
    }
  }

  toggleCreate() {
    this.setState({ closeCreate: !this.state.closeCreate });
    this.clearSelectedReportState();
  }
  toggleActions() {
    this.setState({ closeActions: !this.state.closeActions });
  }
  ClearHeaderCheckBoxSelection(){
    let mainCkBox = document.getElementById("selectAllCheckbox");
    if (mainCkBox.checked) mainCkBox.checked = false;  
  }
  viewrunhistory_toggle() {
    this.setState({ viewrunhistory_Modal: !this.state.viewrunhistory_Modal });
    if (this.state.viewrunhistory_Modal) {
      this.clearSelectedReportState();
      this.ClearHeaderCheckBoxSelection();
    }
  }

  toggleDelete() {
    this.setState({ deleteModal: !this.state.deleteModal });
  }
  toggleEditName() {
    this.setState({ editNameModal: !this.state.editNameModal });
    if (this.state.editNameModal) {
      this.clearSelectedReportState();
      this.ClearHeaderCheckBoxSelection();
    }
  }

  deleteReports = () => {
    if (this.state.hasMultipleSelected || this.state.selectedReportId > 0)
      this.toggleDelete();
  };

  moreTextClick = (e) => {
    e.currentTarget.setAttribute(
      "data-active",
      e.currentTarget.getAttribute("data-active") !== "true"
    );
  };

  Delete = (arg) => {
    if (arg === "yes") {
      this.toggleDelete();
      SelectAllCheckboxes.ResetHeaderCheckBox("defRows", "main_UserCheck_box");
      var Data = [];
      var ckboxes = document.getElementsByClassName("defRows");

      for (var itm of ckboxes) {
        if (itm.checked) {
          var itmVals = itm.id.split("&");
          if (itmVals.length >= 1) Data.push(itmVals[0]);
        }
      }

      if (Data.length > 0) {
        this.props.DeleteReports(Data);
        this.toggleDelete();
        this.clearSelectedReportState();
      }
    } else {
      this.toggleDelete();
      this.clearSelectedReportState();
    }
    this.ClearHeaderCheckBoxSelection();
  };

  editName = () => {
    if (
      this.state.selectedReportId > 0 &&
      this.state.selectedReportType > 0 &&
      this.state.selectedReportName !== ""
    ) {
      if (
        this.state.shortReportList.length === 0 &&
        this.props.ReportsList.length > 0
      ) {
        var sList = [];
        this.props.ReportsList.forEach(function (el) {
          var id = el.id;
          var name = el.name;
          sList.push({ id, name });
        });

        if (sList.length > 0) this.setState({ shortReportList: sList });
      }
      this.toggleEditName();
    }
  };

  UpdateName = (reportName, reportId) => {
    if (reportName && reportName.length > 0) {
      this.toggleEditName();
      this.props.UpdateReportDefinition(reportId, reportName);
      this.toggleEditName();
      this.clearSelectedReportState();
    }
  };

  clearSelectedReportState() {
    this.setState({ selectedReportId: 0 });
    this.setState({ selectedReportName: "" });
    this.setState({ selectedExtension: "" });
    this.setState({ selectedNumArtifacts: 0 });
    this.setState({ hasMultipleSelected: false });
    this.setState({ selectedReportType: 0 });
    this.setState({ timerSpan: 0 });
    this.uncheckValues();
    var IsFromReportSchedules;
    IsFromReportSchedules = sessionStorage.getItem("IsFromReportSchedules");
    if (IsFromReportSchedules !== undefined && IsFromReportSchedules !== null) {
      sessionStorage.removeItem("IsFromReportSchedules");
    }

    var SelectedReportDetails;
    SelectedReportDetails = sessionStorage.getItem("SelectedReportDetails");
    if (SelectedReportDetails !== undefined && SelectedReportDetails !== null) {
      sessionStorage.removeItem("SelectedReportDetails");
    }
  }

  uncheckValues() {
    var ckboxes = document.getElementsByClassName("defRows");
    for (var itm of ckboxes) {
      if (itm.checked) {
        itm.checked = false;
      }
    }
  }

  uncheckNonGenerating(isGenerating, generatingRptId) {
    var ckboxes = document.getElementsByClassName("defRows");
    var ct = 0;

    if (isGenerating) {
      for (var itm of ckboxes) {
        if (itm.checked) {
          if (ct === 0) {
            var spl = itm.id.split("&");
            if (spl.length >= 2) {
              if (spl[0] === generatingRptId) {
                itm.checked = true;
                ct++;
              } else {
                itm.checked = false;
              }
            }
          } else {
            itm.checked = false;
          }
        }
      }
    }
  }

  setSelectedReports(SelectedDetails) {
    var isGenerating =
      document.getElementById("loadingArea").style.display === "block";
    var generatingRptId = this.state.selectedReportId;

    if (isGenerating) {
      this.uncheckNonGenerating(isGenerating, generatingRptId);
    } else {
      document.getElementById("longRunningProcess").style.display = "none";
      document.getElementById("noFileGen").style.display = "none";
      var ckboxes = document.getElementsByClassName("defRows");
      var ct = 0;
      var selId = 0;
      var rName = "";
      var tpe = 0;

      for (var itm of ckboxes) {
        if (itm.checked) {
          if (ct === 0) {
            var spl = itm.id.split("&");
            if (spl.length >= 2) {
              selId = spl[0];
              tpe = parseInt(spl[1]);
              rName = itm.name;
            }
          }
          ct++;
        }
      }

      this.setState({ selectedReportId: ct > 1 ? 0 : selId });
      this.props.setSelectedReportID(selId);

      if (SelectedDetails !== undefined && SelectedDetails !== null) {
        sessionStorage.setItem(
          "SelectedReportDetails",
          JSON.stringify(SelectedDetails)
        );
      }
      this.setState({ hasMultipleSelected: ct > 1 });
      this.setState({ selectedReportType: ct === 1 && tpe > 0 ? tpe : 0 });
      this.setState({
        selectedReportName: ct === 1 && rName !== "" ? rName : "",
      });
      SelectAllCheckboxes.ResetHeaderCheckBox("defRows", "main_UserCheck_box");
    }
  }

  getScheduleLink = () => {
    var rptId = this.state.selectedReportId;
    var sLink =
      this.state.scheduleLink === ""
        ? this.constructBaseUrl("schedule")
        : this.state.scheduleLink;
    var rpt = this.props.ReportsList.filter((x) => x.id === parseInt(rptId));
    var emailTmplId = 0;

    if (rpt.length > 0) emailTmplId = rpt[0].emailTemplateId;

    var rptEmailTmplId = emailTmplId + "-" + rptId;

    if (this.state.selectedReportId !== 0 && sLink !== "") {
      return (
        sLink +
        "?TemplateId=" +
        emailTmplId +
        "&ReportId=" +
        rptId +
        "&ReportType=1&ReplaceSchedule=0&EditSchedule=1&ActiveTab=1&ReportAndTemplateIds=" +
        rptEmailTmplId
      );
    }
    return "";
  };

  createArtifact = (tpe) => {
    if (this.state.selectedReportId > 0) {
      var ext = tpe.toLowerCase() === "excel" ? ".xlsx" : tpe.toLowerCase();
      this.setState({ selectedExtension: ext });
      var fileFormat = { type: tpe };
      var report_ID = this.state.selectedReportId;
      // remove special characters from report name @"[^\w\.@-]"
      var rptName = this.state.selectedReportName.replace(/[^\w.@-]/g, "");
      var rpt = this.props.ReportsList.filter(
        (x) => x.id === parseInt(report_ID)
      );

      if (rpt != null && rpt.length > 0) {
        this.setState({ selectedNumArtifacts: rpt[0].numArtifacts });
      }

      if (tpe.toLowerCase() === 'rdl') {
        // add the month day year and seconds to the file name 7312024620
        var d = new Date();
        var month = d.getMonth() + 1;
        var day = d.getDate();
        var year = d.getFullYear();
        var seconds = d.getSeconds();
        var minutes = d.getMinutes();
        var hours = d.getHours();
        var date = month + "" + day + "" + year + "" + hours + "" + minutes + "" + seconds;
        rptName = rptName + "_" + date;
        this.props.getArtifactTemplate(
          this.state.selectedReportId,
          rptName
        );
      } else {
        tpe = tpe === 'pdf' ? 'PDF' : tpe;
        let src = this.state.selectedReportType > 0 && this.state.selectedReportType !== 99 ? "Standard" : "Custom";

        this.sendGenerateInfoToAmplitude(tpe, src);
        this.props.runReports(report_ID, fileFormat);
      }
    }
  };

  createExport = (tpe) => {
    if (
      this.state.selectedReportId > 0 &&
      this.state.selectedReportType === 99
    ) {
      var ext = tpe.toLowerCase() === "excel" ? ".xlsx" : tpe.toLowerCase();
      this.setState({ selectedExtension: ext });
      var fileFormat = { type: tpe };
      var report_ID = this.state.selectedReportId;
      var rpt = this.props.ReportsList.filter(
        (x) => x.id === parseInt(report_ID)
      );

      if (rpt != null && rpt.length > 0) {
        this.setState({ selectedNumArtifacts: rpt[0].numArtifacts });
      }

      let fileType = tpe.toLowerCase() === 'excel' ? "Excel" : "CSV";
      this.sendGenerateInfoToAmplitude(fileType, "Data Export")
      this.props.runReports(report_ID, fileFormat);
    }
  };

  sendGenerateInfoToAmplitude(fileType, reportType) {
    console.log(fileType, reportType);
    setAmplitudeEvent(" Generate Report",
    {
      "Report Type": reportType,
      "File Type": fileType,
      "Generated From": "List Page",
    });
  }

  run_report_success = (data) => {
    if (data !== undefined && data !== null) {
      var self = this;
      var numExisting = this.state.selectedNumArtifacts;
      var id = this.state.selectedReportId; 
      var ext = this.state.selectedExtension.startsWith(".") ? this.state.selectedExtension : "."  + this.state.selectedExtension;
      var rptName = this.state.selectedReportName + ext;

      var numAttempts = 0;

      //if data is a number,  we did not get a response with a file name and need to retry
      var retry = data !== "" && !isNaN(data);
      var idAsInt = id && id !== null && !isNaN(id) ? parseInt(id) : 0;

      if (idAsInt > 0 && ((data && data.type) || retry)) {
        numAttempts = retry ? data : 0;

        if (numAttempts < MAX_GENERATE_ATTEMPTS) {
          self.sleepFirst(idAsInt, numExisting, rptName, numAttempts);
        } else {
          document.getElementById("loadingArea").style.display = "none";
          document.getElementById("longRunningProcess").style.display = "block";
        }
      } else if (data === "" && idAsInt > 0) {
        var rpt = this.props.ReportsList.filter((x) => x.id === idAsInt);
        // increment # artifacts in case we call for generation again
        if (rpt != null && rpt.length > 0) {
          rpt[0].numArtifacts++;
        }
        self.clearSelectedReportState();
      }
    }
  };

  async sleepFirst(id, numExisting, rptName, numAttempts) {
    await new Promise((r) => setTimeout(r, 2000)); // wait for 2 seconds before retry
    this.props.getArtifactFilename(
      id,
      numExisting,
      rptName,
      numAttempts,
      MAX_GENERATE_ATTEMPTS
    );
  }

  getReportsSubList = (id) => (e) => {
    if (id > 0) {
      this.props.getReportsSubList(id);
      this.viewrunhistory_toggle();
    }
  };


  getMoreScheduletext = (fullList) => {
    if (fullList.length > 0) {
      return fullList
        .split("|")
        .slice(1)
        .map((item, i) => <li key={i}>{item}</li>);
    }
  };

  constructBaseUrl = (urlType) => {
    let pName = window.location.pathname.substring(1);
    let rptUrl = "";

    if (pName.indexOf("/React/") > 0) {
      let ensRoot = pName.indexOf("/");
      let targetPage = "";
      if (urlType === "standard")
        targetPage = "/ReportManagement/ManageStandardReport.aspx?ActiveTab=0";
      else if (urlType === "custom")
        targetPage = "/DataVisualization/Designer.aspx";
      else if (urlType === "export") targetPage = "";
      else if (urlType === "schedule")
        targetPage = "/ReportManagement/ManageReportSchedules.aspx";

      pName = pName.substring(0, ensRoot);
      rptUrl =
        window.location.protocol +
        "//" +
        window.location.host +
        "/" +
        pName +
        targetPage;
    }

    return rptUrl;
  };

  desc_or_reportContent = (el, labelText, i, filtered_data) => {
    if (el.typeName === "Data Export") {
      return el.description;
    } else {
      return el.desc.includes("...") ? (
        <div style={{ float: "left" }}>
          <div style={{ float: "left" }}>
            {" "}
            <p className="description_text">
              {el.desc}
              <span
                className="tooltips"
                onClick={(e) => {
                  this.moreTextClick(e);
                }}
              >
                {labelText["More.Text"] !== undefined
                  ? labelText["More.Text"]
                  : "More"}
                <span
                  className={
                    i <= filtered_data.length - 6
                      ? "tooltiptexts"
                      : "topTooltiptexts"
                  }
                >
                  <span className="limitedtooltiptext">{el.longDesc}</span>
                </span>
              </span>
            </p>
          </div>
        </div>
      ) : (
        el.desc
      );
    }
  };

  render() {
    let filtered_data;
    let pagination_total,
      indexOfLastTodo,
      indexOfFirstTodo = 0;

    let hasFullaccess = this.props.userHasFullaccess;
    hasFullaccess =
      hasFullaccess !== undefined && hasFullaccess !== null && hasFullaccess
        ? true
        : false;

    let { closeCreate, closeActions, searchTerm } = this.state;
    const { currentPagination, pagination_records_PerPage } = this.state;
    let labelText = this.props.getLabels;
    let reports_list = (
      <tr>
        <td colSpan="5">{labelText["NoRecords.Text"]}</td>
      </tr>
    );
    let rptLinkForReport =
      this.state.customReportLink !== ""
        ? this.state.customReportLink + "?ReportId="
        : "";
    let hasReportLink = this.state.customReportLink !== "";
    this.run_report_success(this.props.RunReport_status);
    let isGenerating = document.getElementById("loadingArea")
      ? document.getElementById("loadingArea").style.display === "block"
      : false;

    if (this.state.IsRedirecttoDataExport) {
      return <Redirect to={"/ManageReports/DataExport"} />;
    }

    if (
      this.props.ReportsList.length !== 0 &&
      Array.isArray(this.props.ReportsList)
    ) {
      let filtered_data_test = this.props.ReportsList.filter(
        createFilter(searchTerm, KEYS_TO_FILTERS)
      );
      pagination_total = filtered_data_test.length;
      indexOfLastTodo = currentPagination * pagination_records_PerPage;
      indexOfFirstTodo = indexOfLastTodo - pagination_records_PerPage;

      if (filtered_data_test.length <= 15) {
        indexOfFirstTodo = 0;
        indexOfLastTodo = 15;
      }
      filtered_data = filtered_data_test.slice(
        indexOfFirstTodo,
        indexOfLastTodo
      );

      if (filtered_data.length !== 0) {
        reports_list = filtered_data.map((el, i) => (
          <tr key={el.id}>
            <td style={border_color} className="width2Percent">
              <input
                type="checkbox"
                id={el.id + "&" + el.type}
                className="defRows"
                name={el.name}
                onClick={() => {
                  this.setSelectedReports(el);
                }}
              />
            </td>
            <td style={border_color} className="width20Percent">
              <span
                style={
                  !hasReportLink || el.type !== -1
                    ? displayHidden
                    : displayUnHidden
                }
              >
                {hasFullaccess ? (
                  <a href={rptLinkForReport + el.id + "&numArt=" + el.numArtifacts}>{el.name}</a>
                ) : (
                  el.name
                )}
              </span>
              <span
                style={
                  (hasReportLink && el.type === -1) ||
                    (el.type === 99 && hasFullaccess)
                    ? displayHidden
                    : displayUnHidden
                }
                className="rptName"
              >
                {el.name}
              </span>
              <span
                style={
                  el.type === 99 && hasFullaccess
                    ? { color: "#6890C6", displayUnHidden }
                    : displayHidden
                }
                className={
                  el.type === 99 && hasFullaccess
                    ? "link_cursor rptName"
                    : "rptName"
                }
                onClick={() => {
                  this.viewDataExport(el.id, el);
                }}
              >
                {el.name}
              </span>
            </td>
            <td style={border_color} className="width10Percent">
              {el.typeName}
            </td>
            <td style={border_color} className="width10Percent">
              {el.lastModified}
            </td>
            <td style={border_color} className="width30Percent">
              {this.desc_or_reportContent(el, labelText, i, filtered_data)}
            </td>
            <td style={borderColorBreakWord} className="width28Percent">
              <div style={{ float: "left" }}>
                {el.firstScheduleText.length === 0
                  ? "---"
                  : el.firstScheduleText + "  "}{" "}
              </div>
              {!isNaN(el.numSchedules) && parseInt(el.numSchedules) > 1 ? (
                <div style={{ float: "left" }}>
                  <div style={{ float: "left" }}>
                    <span
                      className="tooltips"
                      onClick={(e) => {
                        this.moreTextClick(e);
                      }}
                    >
                      {" "}
                      {"  +" +
                        (parseInt(el.numSchedules) - 1).toString() +
                        " " +
                        "More"}
                      <span
                        className={
                          i <= filtered_data.length - 3
                            ? "tooltiptexts"
                            : "topTooltiptexts shortMessage"
                        }
                      >
                        <ul className="custom_tooltip_text">
                          {this.getMoreScheduletext(el.allScheduleText)}
                        </ul>
                      </span>
                    </span>
                  </div>
                </div>
              ) : (
                <p> {""}</p>
              )}
            </td>
          </tr>
        ));
      }
    }

    return (
      <div className="main_container">
        <div
          style={{
            marginBottom: "10px",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span className="PageTitleBar" style={{ paddingLeft: "0px" }}>
            {labelText["Reports.Text"] !== undefined
              ? labelText["Reports.Text"]
              : "Reports"}
          </span>
          <div>
            <Tooltip title="Reports Help">
              <IconButton
                style={{ textAlign: "right", width: "25px", height: "25px" }}
                onClick={() => {
                  window.open(videoUrl, windowName, windowFeatures);
                  setAmplitudeEvent("Help Videos", {
                    Source: "Icon",
                    "Video Name": "Introduction to Reports",
                    "Page URL":
                      "/React/Home.aspx?Page=ManageReports#/ManageReports/ManageReportsDefinitions8",
                  });
                }}
              >
                <PlayIcon style={{ width: "25px", height: "25px" }} />
              </IconButton>
            </Tooltip>
          </div>
        </div>
        <div className="reports_top_container ">
          <div className="reports_buttons flexButtonArea">
            <UncontrolledButtonDropdown
              isOpen={closeActions}
              toggle={this.toggleActions}
            >
              <DropdownMenu>
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  style={
                    this.state.selectedReportType !== 99
                      ? displayUnHidden
                      : displayHidden
                  }
                  disabled={this.state.selectedReportId === 0 || isGenerating}
                  onClick={() => this.createArtifact("pdf")}
                >
                  {labelText["DownloadPDF.Text"] !== undefined
                    ? labelText["DownloadPDF.Text"]
                    : "Generate PDF"}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  style={
                    this.state.selectedReportType === 99
                      ? displayUnHidden
                      : displayHidden
                  }
                  onClick={() => this.createExport("csv")}
                >
                  {labelText["ExportCSV.Text"] !== undefined
                    ? labelText["ExportCSV.Text"]
                    : "Export CSV"}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  style={
                    this.state.selectedReportType === 99
                      ? displayUnHidden
                      : displayHidden
                  }
                  onClick={() => this.createExport("excel")}
                >
                  {labelText["ExportExcel.Text"] !== undefined
                    ? labelText["ExportExcel.Text"]
                    : "Export Excel"}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  style={
                    this.state.selectedReportType === 0 && !isGenerating
                      ? displayUnHidden
                      : displayHidden
                  }
                  disabled={this.state.selectedReportId === 0}
                  onClick={() => this.createArtifact("Excel")}
                >
                  {labelText["DownloadExcel.Text"] !== undefined
                    ? labelText["DownloadExcel.Text"]
                    : "Generate Excel"}
                </DropdownItem>
                <DropdownItem
                  divider
                  style={
                    hasReportLink
                      ? { marginBottom: "8px" }
                      : { marginBottom: "initial" }
                  }
                />
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  style={
                    this.state.selectedReportId !== 0
                      ? displayHidden
                      : displayUnHidden
                  }
                  disabled
                >
                  {labelText["Schedules.Text"] !== undefined
                    ? labelText["Schedules.Text"]
                    : "Schedules"}
                </DropdownItem>

                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  onClick={this.redirecttoDataExportSchedules}
                  style={
                    this.state.selectedReportId === 0
                      ? displayHidden
                      : displayUnHidden
                  }
                >
                  {labelText["Schedules.Text"] !== undefined
                    ? labelText["Schedules.Text"]
                    : "Schedules"}
                </DropdownItem>
                {/* <DropdownItem className="reports_menu_dropdown_item singleOnly" tag="a" href={this.getScheduleLink()} style={this.state.selectedReportId === 0 || !hasReportLink ? displayHidden : displayUnHiddenVerdana}>{labelText['Schedules.Text']}</DropdownItem> */}
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  style={
                    this.state.selectedReportId === 0 || !hasReportLink
                      ? displayWithBorder
                      : displayWithMargin
                  }
                  disabled={this.state.selectedReportId === 0}
                  onClick={this.getReportsSubList(this.state.selectedReportId)}
                >
                  {labelText["ReportHistory.Text"] !== undefined
                    ? labelText["ReportHistory.Text"]
                    : "Report History"}
                </DropdownItem>
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  style={
                    this.state.selectedReportType === 0 && !isGenerating
                      ? displayUnHidden
                      : displayHidden
                  }
                  disabled={this.state.selectedReportId === 0}
                  onClick={() => this.createArtifact("rdl")}
                >
                  {labelText["ExportAsTemplate.Text"] !== undefined
                    ? labelText["ExportAsTemplate.Text"]
                    : "Export as Template"}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  className="reports_menu_dropdown_item singleOnly"
                  hidden={!hasFullaccess}
                  style={
                    this.state.selectedReportType === 0 ||
                      this.state.selectedReportType === 99
                      ? displayHidden
                      : displayUnHidden
                  }
                  disabled={this.state.selectedReportId === 0}
                  onClick={() => this.editName()}
                >
                  {labelText["EditName.Text"] !== undefined
                    ? labelText["EditName.Text"]
                    : "Edit Name"}
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  className="reports_menu_dropdown_item"
                  hidden={!hasFullaccess}
                  disabled={
                    !this.state.hasMultipleSelected &&
                    this.state.selectedReportId === 0
                  }
                  onClick={() => this.deleteReports()}
                >
                  {labelText["ManageSavedReports.btnDelete.Text"] !== undefined
                    ? labelText["ManageSavedReports.btnDelete.Text"]
                    : "Delete"}
                </DropdownItem>
              </DropdownMenu>
              <DropdownToggle
                caret
                className="CR_btn_Dropdown_action_caret CR_btn_Dropdown_caret_gray"
                onClick={() => this.toggleActions}
              >
                Actions &nbsp;&nbsp;&nbsp;&nbsp;
              </DropdownToggle>
            </UncontrolledButtonDropdown>

            <span>
              <input type="hidden" id="hdnArtifactFilename" value="" />
            </span>
          </div>
          <div className="flexMsgArea">
            <span
              id="loadingArea"
              style={{ display: "none", color: "#323232" }}
            >
              <img
                className="rpt_actions_img"
                src={progressindicator}
                id="loadingGIF"
                alt="loader"
              />{" "}
              {labelText["Generating.Text"] !== undefined
                ? labelText["Generating.Text"]
                : "Generating..."}
            </span>
            <span id="longRunningProcess" style={{ display: "none" }}>
              {labelText["LongRunningProcess.Text"] !== undefined
                ? labelText["LongRunningProcess.Text"]
                : 'The report is still generating. Please check back later under "Report History" for the result.'}
            </span>
            <span
              id="noFileGen"
              className="RM_errorMessage"
              style={{ display: "none" }}
            >
              <img src={errorImage} alt="Error" />
              {labelText["UnableToGenerate.Text"] !== undefined
                ? labelText["UnableToGenerate.Text"]
                : "Unable to generate a file for the selected report."}
            </span>
          </div>
          <div className="reports_filter_system flexSearchArea">
            <span>
              <SearchInput
                className="report_search_input"
                onChange={this.searchUpdated}
                id="searchInput"
              />
            </span>
          </div>
          <div className="reports_actions_buttons flexButtonArea reports_actions_alignRight">
            <Dropdown
              isOpen={closeCreate}
              toggle={this.toggleCreate}
              hidden={!hasFullaccess}
            >
              <DropdownMenu>
                <DropdownItem
                  href={!hasReportLink ? "" : this.state.customReportLink}
                  className="reports_menu_dropdown_item"
                >
                  <span
                    style={!hasReportLink ? displayHidden : displayUnHidden}
                  >
                    <a
                      href={this.state.customReportLink}
                      style={{
                        color: "#212529",
                        fontFamily: "Verdana",
                        fontWeight: "bolder",
                        whiteSpace: "normal !important",
                        verticalAlign: "middle !important",
                      }}
                    >
                      {labelText["CustomReport.Text"] !== undefined
                        ? labelText["CustomReport.Text"]
                        : "Custom Report"}
                    </a>
                  </span>
                  <span style={hasReportLink ? displayHidden : displayUnHidden}>
                    {labelText["CustomReport.Text"] !== undefined
                      ? labelText["CustomReport.Text"]
                      : "Custom Report"}
                  </span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  onClick={this.redirecttoDataExport}
                  className="reports_menu_dropdown_item"
                >
                  <span onClick={this.redirecttoDataExport}>
                    {labelText["DataExport.Text"] !== undefined
                      ? labelText["DataExport.Text"]
                      : "Data Export"}
                  </span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  href={!hasReportLink ? "" : this.state.standardReportLink}
                  className="reports_menu_dropdown_item"
                >
                  <span
                    style={!hasReportLink ? displayHidden : displayUnHidden}
                  >
                    <a
                      href={this.state.standardReportLink}
                      style={{
                        color: "#212529",
                        fontFamily: "Verdana",
                        fontWeight: "bolder",
                        whiteSpace: "normal !important",
                        verticalAlign: "middle !important",
                      }}
                    >
                      {labelText["StandardReport.Text"] !== undefined
                        ? labelText["StandardReport.Text"]
                        : "Standard Report"}
                    </a>
                  </span>
                  <span style={hasReportLink ? displayHidden : displayUnHidden}>
                    {labelText["StandardReport.Text"] !== undefined
                      ? labelText["StandardReport.Text"]
                      : "Standard Report"}
                  </span>
                </DropdownItem>
                <DropdownItem divider />
                <DropdownItem
                  className="reports_menu_dropdown_item"
                  hidden={!hasFullaccess}
                  onClick={() => this.setState({ importFileModal: true, importFileNameError: false, FileReportName: null, importFile: null,  importFileUploadError: false,  importFileUploadErrorCode: "", openInEditor: false, })}
                >
                  {labelText["ImportReport.Text"] !== undefined
                    ? labelText["ImportReport.Text"]
                    : "Import Report Template"}
                </DropdownItem>
              </DropdownMenu>

              <DropdownToggle
                caret
                className="CR_btn_Dropdown_caret"
                onClick={() => this.toggleCreate}
              >
                {labelText["CreateNew.Text"] !== undefined
                  ? labelText["CreateNew.Text"]
                  : "Create    "}{" "}
                &nbsp;&nbsp;
              </DropdownToggle>
            </Dropdown>
          </div>
        </div>

        <div className="table_container">
          <Table responsive className="customised_green_table">
            <thead>
              <tr>
                <th style={border_color} className="width2Percent">
                  <input
                    type="checkbox"
                    id="selectAllCheckbox"
                    className="main_UserCheck_box"
                    onClick={() => {
                      SelectAllCheckboxes.selectAllCheckbox(
                        "defRows",
                        "main_UserCheck_box"
                      );
                      this.setSelectedReports();
                    }}
                  />
                </th>
                <th
                  onClick={this.onSort("name")}
                  className="link_cursor width20Percent"
                  style={border_color}
                >
                  {labelText["ManageStandardReport.lblReportName.Text"]}{" "}
                  <span
                    style={{ backgroundColor: "red !important" }}
                    className={this.setArrow("name").className}
                  ></span>{" "}
                  <FaSort
                    style={{
                      ccolor: "#d5d5d5",
                      display: this.setArrow("name").style,
                    }}
                  />{" "}
                </th>
                <th
                  onClick={this.onSort("typeName")}
                  className="link_cursor width10Percent"
                  style={border_color}
                >
                  {labelText["ManageStandardReport.lblReportType.Text"] !==
                    undefined
                    ? labelText["ManageStandardReport.lblReportType.Text"]
                    : "Report Type"}{" "}
                  <span className={this.setArrow("typeName").className}></span>{" "}
                  <FaSort
                    style={{
                      ccolor: "#d5d5d5",
                      display: this.setArrow("typeName").style,
                    }}
                  />{" "}
                </th>
                <th
                  onClick={this.onSort("lastModifiedDate")}
                  className="link_cursor width10Percent"
                  style={border_color}
                >
                  {labelText["LastModified.Text"] !== undefined
                    ? labelText["LastModified.Text"]
                    : "Last Modified"}
                  <span
                    className={this.setArrow("lastModifiedDate").className}
                  ></span>{" "}
                  <FaSort
                    style={{
                      ccolor: "#d5d5d5",
                      display: this.setArrow("lastModifiedDate").style,
                    }}
                  />
                </th>
                <th
                  onClick={this.onSort("desc")}
                  className=" link_cursor width30Percent"
                  style={border_color}
                >
                  {labelText["DescriptionReportContent.Text"] !== undefined
                    ? labelText["DescriptionReportContent.Text"]
                    : "Description/Report Content"}{" "}
                  <span className={this.setArrow("desc").className}></span>{" "}
                  <FaSort
                    style={{
                      ccolor: "#d5d5d5",
                      display: this.setArrow("desc").style,
                    }}
                  />{" "}
                </th>
                <th
                  onClick={this.onSort("firstScheduleText")}
                  className="link_cursor width28Percent"
                  style={border_color}
                >
                  {labelText["StandardReportGrid.ScheduleName.Text"]}{" "}
                  <span
                    className={this.setArrow("isScheduled").className}
                  ></span>{" "}
                  <FaSort
                    style={{
                      ccolor: "#d5d5d5",
                      display: this.setArrow("isScheduled").style,
                    }}
                  />{" "}
                </th>
                <th className="link_cursor" style={displayHidden}>
                  {"ACTIONS"}{" "}
                </th>
              </tr>
            </thead>
          </Table>
        </div>
        {filtered_data !== null &&
          filtered_data !== undefined &&
          filtered_data.length > 3 ? (
          <div
            className="table_container heightAsPercent"
            style={{ overflowY: "auto" }}
          >
            <Table
              responsive
              className="customised_green_table"
              style={{ overflow: "hidden" }}
            >
              <tbody>{reports_list}</tbody>
            </Table>
          </div>
        ) : (
          <div className="table_container heightAsPercent">
            <Table className="customised_green_table">
              <tbody>{reports_list}</tbody>
            </Table>
          </div>
        )}

        <Modal
          isOpen={this.state.viewrunhistory_Modal}
          className={classnames(
            { classnames: this.props.className },
            "viewrunhistory "
          )}
        >
          <ViewRunHistory
            viewrunhistory_toggle={this.viewrunhistory_toggle}
            parentToChildData={[
              this.state.selectedReportName,
              this.state.selectedReportId,
            ]}
          />
        </Modal>

        <Modal
          isOpen={this.state.deleteModal}
          deletemodal={this.deleteModal}
          className={classnames(
            { classnames: this.props.className },
            "RM_ModalContainer"
          )}
        >
          <DeleteConfirmation
            parentToChildData={[
              labelText["Delete.Text"] !== undefined
                ? labelText["Delete.Text"]
                : "Delete",
              labelText["DeleteReportConfirmation.Text"] !== undefined
                ? labelText["DeleteReportConfirmation.Text"]
                : "You are about to delete one or more report definitions and their related generated reports. Do you want to continue?",
            ]}
            Delete={this.Delete}
          />
        </Modal>

        <Modal
          isOpen={this.state.editNameModal}
          className={classnames(
            { classnames: this.props.className },
            "editname"
          )}
        >
          <EditName
            toggleEditName={this.toggleEditName}
            parentToChildData={[
              this.state.selectedReportName,
              this.state.selectedReportId,
            ]}
            UpdateName={this.UpdateName}
            ReportsList={this.state.shortReportList}
          />
        </Modal>

        <Pagination
          itemRender={textItemRender}
          showTitle={true}
          onChange={this.onChange}
          defaultPageSize={this.state.pagination_records_PerPage}
          current={this.state.currentPagination}
          showTotal={(total, range) =>
            `(Viewing ${range[0]} - ${range[1]} of ${total})   `
          }
          total={pagination_total}
          selectComponentClass={Select}
          showSizeChanger
          onShowSizeChange={this.onShowSizeChange}
          defaultCurrent={3}
          pageSizeOptions={["50", "100", "150", "200"]}
          locale={localeInfo}
        />
        <Modal
          fade={false}
          isOpen={this.state.importFileModal}
          style={{ alignContent: "center", justifyContent: "center", width: "100%", paddingLeft: "20px" }}
        >
          <ModalHeader>
            <span className="PageTitleBar" style={{ paddingLeft: "0px" }}>
              Import Report Template
            </span>
          </ModalHeader>
          <ModalBody>
            <div className="row">
              <div className="col-md-12">
                <label htmlFor="report-name" className="col-form-label">
                  {labelText['ImportTemplate.UA.Text'] === undefined ? 'Give a unique name to this imported report. Description is optional. Upon success save, a new report will be available based on this template. You will need to add data sources and other site specific information to any charts or tables originally part of this template. You can add additional items to the new report, as desired.' : labelText['ImportTemplate.UA.Text']}
                </label>
              </div>
              <div className="col-md-12">
                {/* drag and drop attachment */}
                <TraneDragAndDrop
                  labels={this.props.getLabels}
                  buildFileData={(fileData) => {
                    this.setState({ importFile: fileData })
                  }}
                  importFileUploadError={this.state.importFileUploadError}
                  importFileUploadErrorCode={this.state.importFileUploadErrorCode}
                />
              </div>

              <div className="col-md-12">
                <div className="form-group" style={{ marginBottom: '0px' }}>
                  <div className="row">
                    <div className="col-md-3" style={{ paddingTop: "10px" }}>
                      <label htmlFor="report-name" className="col-form-label">
                        {
                          labelText['ManageStandardReport.lblReportName.Text'] === undefined ? 'Report Name' : labelText['ManageStandardReport.lblReportName.Text']
                        }
                      </label>
                    </div>
                    <div className="col-md-5" style={{ paddingTop: "10px" }}>
                      <Input className="customInput default-input" id='reportName' ref="asdf" type="text" maxLength="50" name="Report Name" defaultValue={this.state.FileReportName}
                        onChange={e => this.setState({ FileReportName: e.target.value })} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div id='dupError' style={{ display: 'none', color: 'red', fontWeight: 'bold' }}><img src={ErrorGif} alt="Error" /> {labelText['ReportManagement.DuplicateValidationerror.Text'] !== undefined ? labelText['ReportManagement.DuplicateValidationerror.Text'] : "Error: Report Name already exists."}</div>
                <div id='illegalCharError' style={{ display: 'none', color: 'red', fontWeight: 'bold' }}><img src={ErrorGif} alt="Error" /> {labelText['ReportManagement.IllegalCharError.Text'] !== undefined ? labelText['ReportManagement.IllegalCharError.Text'] : "Error: Report Name contains characters other than letters and numbers."}</div>
                <div id='tooManyCharacters' style={{ display: 'none', color: 'red', fontWeight: 'bold' }}><img src={ErrorGif} alt="Error" /> {labelText['ReportManagement.OverMax.Text'] !== undefined ? labelText['ReportManagement.OverMax.Text'] : "Error: The text has over the maximum number of characters allowed."}</div>
              </div>
              <div className="col-md-12" style={{ height: "30px" }}>
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-3" >
                      <label htmlFor="report-name" className="col-form-label">
                        {
                          labelText['ManageStandardReport.lblDescription.Text'] === undefined ? 'Description' : labelText['ManageStandardReport.lblDescription.Text']
                        }                      
                      </label>
                    </div>
                    <div className="col-md-5" >
                      <Input className="customInput default-input" type="text" name="Description"
                        edefaultValue={this.state.fileDescription} onChange={e => this.setState({ fileDescription: e.target.value })} />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-12">
                <div className="form-group">
                  <div className="row">
                    <div className="col-md-10" >
                      {/* checkbox for opening report in editor */}
                      <input style={{ paddingTop: '10px' }} type="checkbox" id="openInEditor" name="openInEditor" value={this.state.openInEditor} onChange={() => {
                        this.setState({
                          openInEditor: !this.state.openInEditor
                        })
                      }} />
                      <label htmlFor="openInEditor" className="col-form-label" style={{ paddingLeft: '10px' }}>
                        {
                          labelText['OpenInReportEditor.Text'] === undefined ? 'Open in editor upon successful import' : labelText['OpenInReportEditor.Text']
                        }                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ModalBody>
          <ModalFooter
            style={{ alignContent: "left", justifyContent: "left" }}
          >
            <Button
              className="btn-gray uniform-button"
              onClick={(e) => {
                e.stopPropagation();
                this.clearStateValues();
              }}
              id="cancelAttemptedLoginButton"
              style={{ marginRight: "50px" }}
            >
              Cancel
            </Button>
            <Button
              disabled={this.state.FileReportName === null || this.state.FileReportName === "" || this.state.importFile === null}
              className="btn-success uniform-button"
              onClick={this.checkReportTemplateName}
              outline={false}
              id="AttemptedLoginButton"
            >
              Import
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }

  onSort = (column) => (e) => {
    const direction = this.state.sort.column
      ? this.state.sort.direction === "asc"
        ? "desc"
        : "asc"
      : "desc";
    var notequals = 0;
    var data_from_state = this.props.ReportsList;
    if (data_from_state.length > 0) {
      const sortedData = data_from_state.sort((a, b) => {
        const nameA =
          column === "members"
            ? a[column]
              .map((xl) => xl.objectName)
              .join(", ")
              .toLowerCase()
            : a[column].toLowerCase();
        const nameB =
          column === "members"
            ? b[column]
              .map((xl) => xl.objectName)
              .join(", ")
              .toLowerCase()
            : b[column].toLowerCase();

        if (nameA !== null && nameB !== null) {
          if (nameA < nameB) {
            notequals = 1;
            return -1;
          }

          if (nameA > nameB) {
            notequals = 1;
            return 1;
          }

          if (nameA === nameB) {
            return 0;
          }
        }
        return 0;
      });

      if (this.state.sort.direction === "asc" && notequals === 1) {
        sortedData.reverse();
      }

      this.setState({
        sort: {
          column,
          direction,
        },
      });
    }
  };

  setArrow = (column) => {
    let className = "reports-sort-direction";
    if (this.state.sort.column === column) {
      className += this.state.sort.direction === "asc" ? " asc" : " desc";
      return { style: "none", className: className };
    } else {
      return { style: "initial", className: "" };
    }
  };

  // Search & Pagination
  onShowSizeChange = (current, pagination_records_PerPage) => {
    this.setState({
      pagination_records_PerPage: parseInt(pagination_records_PerPage),
      currentPagination: 1,
    });
  };
  onChange = (page) => {
    this.setState({ currentPagination: page });
  };

  searchUpdated = (term) => {
    if (term === "") {
      this.setState({ currentPagination: 1 });
    }
    this.setState({ searchTerm: term });
  };
}

const textItemRender = (current, type, element) => {
  if (type === "prev") {
    return "Previous";
  }
  if (type === "next") {
    return "Next";
  }
  return element;
};

const mapStateToProps = (state) => {
  return {
    getLabels:
      state.CulturalLabelsRootReducer.ReportMgmt_LabelsBasedOnPreference,
    ReportsList: state.ManageReportsRootReducer.MangeReportslist,
    RunReport_status: state.RunReportsRootReducer.RunReport_status,
    userHasFullaccess: state.authService.HasApplicationFullAcess,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getReportsList: () => dispatch(getReportsList()),
    getReportsSubList: (id) => dispatch(getReportsSubList(id)),
    getArtifactTemplate: (id, reportName) => dispatch(getArtifactTemplate(id, reportName)),
    getArtifactFilename: (
      id,
      numExisting,
      reportName,
      numAttempts,
      maxAllowedAttempts
    ) =>
      dispatch(
        getArtifactFilename(
          id,
          numExisting,
          reportName,
          numAttempts,
          maxAllowedAttempts
        )
      ),
    runReports: (report_ID, fileFormat) =>
      dispatch(runReports(report_ID, fileFormat)),
    DeleteReports: (data) => dispatch(DeleteReports(data)),
    UpdateReportDefinition: (reportId, reportName) =>
      dispatch(UpdateReportDefinition(reportId, reportName)),
    DownloadSelectedReport: (artifactFileName, downloadName) =>
      dispatch(DownloadSelectedReport(artifactFileName, downloadName)),
    setSelectedReportID: (reportId) => dispatch(setSelectedReportID(reportId)),
  };
};

// Component Styles
const border_color = {
  borderRight: "1px solid #ededed",
};

const displayHidden = {
  display: "none",
};

const displayUnHidden = {
  display: "inline",
};

const displayWithMargin = {
  borderTop: "1px solid #ededed",
  marginTop: "5px",
};

const displayWithBorder = {
  borderTop: "1px solid #ededed",
};

const borderColorBreakWord = {
  borderRight: "1px solid #ededed",
  wordBreak: "break-word",
};

//End of  Component Styles

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageReportsTabSystem);
